import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

interface ReviewItem {
  id: string;
  authorName: string;
  authorRole: string;
  content: string;
  rating: number;
  providerName: string;
  courseName: string;
  category: string;
  date: string;
  helpful: number;
}

const allReviews: ReviewItem[] = [
  {
    id: "r001",
    authorName: "田中 美咲",
    authorRole: "着物愛好家・埼玉県",
    content: "祖母から受け継いだ訪問着に付いたしみが、どのクリーニング店でも「これ以上は無理」と断られ続けていました。染田先生の講座を受けて自分で処置した結果、15年物のしみがほぼ完全に消えました。購入後のメッセージ機能で直接相談できたことも大きな支えになりました。「諦めていた」が「蘇った」に変わる体験ができる場所は、ここだけだと思います。",
    rating: 5,
    providerName: "しみ抜き専門店 染田",
    courseName: "しみ抜き完全攻略講座",
    category: "しみ抜き",
    date: "2024年12月",
    helpful: 48,
  },
  {
    id: "r002",
    authorName: "佐藤 健一",
    authorRole: "クリーニング業経営者・神奈川県",
    content: "創業20年のクリーニング店を経営していますが、これほど体系的に技術を学べる場が存在するとは知りませんでした。吉村先生の洗い張り講座受講後、外注に出していた工程を内製化でき、月の売上が約18万円改善しました。職人に直接質問できる環境は、他のどの学習プラットフォームにも替えられない価値だと感じています。",
    rating: 5,
    providerName: "京都洗い張り工房 吉村",
    courseName: "洗い張り完全マスター講座",
    category: "和服ケア",
    date: "2025年1月",
    helpful: 62,
  },
  {
    id: "r003",
    authorName: "木村 陽子",
    authorRole: "ファッションスタイリスト・東京都",
    content: "仕事柄、カシミヤやシルクを扱う機会が多く、素材ケアの知識不足をずっと感じていました。講座は化学的な根拠から実際の手順まで、プロが本当に必要な情報だけを凝縮して教えてくれます。受講後は顧客への提案の質が上がり、ケア相談でリピートしてくれる方が増えました。",
    rating: 5,
    providerName: "高級衣類ケア アトリエ・ナカムラ",
    courseName: "カシミヤ完全ケアマスター講座",
    category: "高級衣類ケア",
    date: "2025年2月",
    helpful: 37,
  },
  {
    id: "r004",
    authorName: "渡辺 浩司",
    authorRole: "大工・一級建築士・愛知県",
    content: "宮大工の技術を映像で学べるとは思っていませんでした。継手・仕口の精度の出し方など、見よう見まねでは絶対に身につかない部分を言語化して教えてくれるのが素晴らしい。橋本先生のキットと組み合わせることで、道具の扱い方から理解できました。設計の考え方が根本から変わりました。",
    rating: 5,
    providerName: "宮大工技術研究所 橋本",
    courseName: "宮大工の継手・仕口マスター講座",
    category: "大工・木工",
    date: "2025年1月",
    helpful: 54,
  },
  {
    id: "r005",
    authorName: "中村 優子",
    authorRole: "料理研究家・福岡県",
    content: "発酵食品の基礎から応用まで、ここまで丁寧に解説されたコンテンツは珍しいです。塩分の計算方法、温度管理の科学、失敗した際のリカバリー方法まで網羅されていて、3回目の視聴でも新しい発見があります。教材キットの麹も質が高く、仕込みの成功率が上がりました。",
    rating: 5,
    providerName: "発酵食品工房 小倉",
    courseName: "本格味噌・醤油・糠床 仕込み講座",
    category: "料理・発酵食品",
    date: "2025年2月",
    helpful: 29,
  },
  {
    id: "r006",
    authorName: "松田 剛",
    authorRole: "陶芸教室主宰・京都府",
    content: "轆轤の技術は、言葉や写真では伝えられない「感覚」の部分が大きい。映像で観ることで、師匠の手の動きの微妙な変化を観察できるのが動画講座の最大の強みだと気づきました。受講後に生徒さんへの説明が具体的になり、教室の上達スピードが上がったと好評です。",
    rating: 4,
    providerName: "陶芸工房 山城",
    courseName: "轆轤成形 基礎から応用まで",
    category: "陶芸・工芸",
    date: "2025年3月",
    helpful: 18,
  },
  {
    id: "r007",
    authorName: "林 美奈子",
    authorRole: "和菓子教室受講者・大阪府",
    content: "上生菓子の繊細な細工が、こんなにも体系的に学べるとは思いませんでした。各工程の温度管理、素材の選び方、季節ごとの意匠の考え方まで、職人の哲学が伝わってきます。動画を見ながら手を動かして、失敗しても何度でも見直せる環境が理想的な学習体験でした。",
    rating: 5,
    providerName: "上生菓子工房 和田",
    courseName: "上生菓子 練り切り技法講座",
    category: "和菓子・製菓",
    date: "2025年2月",
    helpful: 41,
  },
  {
    id: "r008",
    authorName: "池田 正",
    authorRole: "理容師（15年）・東京都",
    content: "同業者として、この価格でここまで教えてもらっていいのかと驚きました。刃物の扱い方、カットラインの計算、顔の形に合わせた調整方法が実技映像で解説されており、独学では気づけなかった自分の癖を発見できました。技術の棚卸しとして定期的に見直しています。",
    rating: 5,
    providerName: "理容技術研究所 北村",
    courseName: "伝統理容技術 完全解説講座",
    category: "理容・美容",
    date: "2025年1月",
    helpful: 33,
  },
  {
    id: "r009",
    authorName: "岡本 泉",
    authorRole: "書道教室講師・兵庫県",
    content: "書の基礎技法を改めて映像で学び直したことで、長年の癖が修正されました。筆の選び方、墨の濃度、紙への圧のかけ方など、「当たり前すぎて誰も教えてくれなかった」部分を丁寧に解説してくれているのが特に良かったです。自分の生徒への指導にも活用しています。",
    rating: 4,
    providerName: "書道工房 鈴木",
    courseName: "現代書道 基礎技法徹底解説",
    category: "書道・アート",
    date: "2025年3月",
    helpful: 15,
  },
];

const categories = ["すべて", "しみ抜き", "和服ケア", "高級衣類ケア", "大工・木工", "料理・発酵食品", "陶芸・工芸", "和菓子・製菓", "理容・美容", "書道・アート"];

export default function ReviewsPage() {
  const [catFilter, setCatFilter] = useState("すべて");
  const [sort, setSort] = useState<"newest" | "helpful">("helpful");
  const [helpfulClicked, setHelpfulClicked] = useState<Set<string>>(new Set());

  const filtered = allReviews
    .filter(r => catFilter === "すべて" || r.category === catFilter)
    .sort((a, b) => sort === "helpful" ? b.helpful - a.helpful : 0);

  const toggleHelpful = (id: string) => {
    setHelpfulClicked(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const avgRating = (allReviews.reduce((a, r) => a + r.rating, 0) / allReviews.length).toFixed(1);

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-screen-xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="font-display italic text-gold text-xs tracking-widest mb-2">Reviews</p>
            <h1 className="font-serif text-deep-green text-3xl font-light mb-4">受講者の声</h1>
            <p className="text-charcoal/60 font-sans text-sm mb-8">実際に講座・教材を購入された方からのリアルなレビューです</p>

            {/* Stats */}
            <div className="flex items-center justify-center gap-8 mb-4">
              <div className="text-center">
                <p className="font-serif text-4xl text-deep-green">{avgRating}</p>
                <div className="flex justify-center gap-0.5 my-1">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-lg" style={{ color: i < Math.round(parseFloat(avgRating)) ? "#c9a84c" : "#e5e7eb" }}>★</span>
                  ))}
                </div>
                <p className="text-xs text-charcoal/50 font-sans">平均評価</p>
              </div>
              <div className="w-px h-12 bg-stone-200" />
              <div className="text-center">
                <p className="font-serif text-4xl text-deep-green">{allReviews.length}</p>
                <p className="text-xs text-charcoal/50 font-sans mt-2">件のレビュー</p>
              </div>
              <div className="w-px h-12 bg-stone-200" />
              <div className="text-center">
                <p className="font-serif text-4xl text-deep-green">{allReviews.filter(r => r.rating === 5).length}</p>
                <p className="text-xs text-charcoal/50 font-sans mt-2">★5評価</p>
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
            <div className="flex gap-2 flex-wrap">
              {categories.map(c => (
                <button
                  key={c}
                  onClick={() => setCatFilter(c)}
                  className={`px-3 py-1.5 rounded-full text-xs font-sans cursor-pointer transition-all border whitespace-nowrap ${catFilter === c ? "bg-deep-green text-white border-deep-green" : "bg-white text-charcoal/60 border-stone-200 hover:border-deep-green/40"}`}
                >
                  {c}
                </button>
              ))}
            </div>
            <select
              value={sort}
              onChange={e => setSort(e.target.value as "newest" | "helpful")}
              className="px-4 py-2 rounded-xl border border-stone-200 text-sm font-sans focus:outline-none focus:border-teal bg-white cursor-pointer"
            >
              <option value="helpful">参考になった順</option>
              <option value="newest">新着順</option>
            </select>
          </div>

          {/* Reviews grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {filtered.map(r => (
              <div key={r.id} className="bg-white rounded-2xl p-7 flex flex-col border border-stone-100 hover:-translate-y-1 transition-transform duration-300">
                {/* Stars */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-base" style={{ color: i < r.rating ? "#c9a84c" : "#e5e7eb" }}>★</span>
                  ))}
                  <span className="text-xs text-charcoal/40 font-sans ml-1">{r.rating}.0</span>
                </div>

                {/* Quote */}
                <p className="font-display text-4xl text-gold/20 leading-none mb-1 font-light">"</p>
                <p className="text-charcoal/80 font-sans text-sm leading-relaxed flex-1 mb-5">{r.content}</p>

                {/* Author info */}
                <div className="border-t border-stone-100 pt-4 mb-4">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="font-sans text-charcoal text-sm font-medium">{r.authorName}</p>
                      <p className="text-charcoal/50 text-xs font-sans mt-0.5">{r.authorRole}</p>
                    </div>
                    <p className="text-charcoal/30 text-xs font-sans whitespace-nowrap">{r.date}</p>
                  </div>
                  <div className="flex items-center gap-2 mt-3">
                    <i className="ri-play-circle-line text-teal text-xs" />
                    <Link to="/courses" className="text-teal text-xs font-sans hover:underline">{r.courseName}</Link>
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    <i className="ri-store-2-line text-charcoal/30 text-xs" />
                    <p className="text-charcoal/40 text-xs font-sans">{r.providerName}</p>
                  </div>
                </div>

                {/* Helpful */}
                <button
                  onClick={() => toggleHelpful(r.id)}
                  className={`flex items-center gap-1.5 text-xs font-sans cursor-pointer transition-colors w-fit ${helpfulClicked.has(r.id) ? "text-teal" : "text-charcoal/40 hover:text-charcoal"}`}
                >
                  <i className={`${helpfulClicked.has(r.id) ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-sm`} />
                  参考になった ({r.helpful + (helpfulClicked.has(r.id) ? 1 : 0)})
                </button>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center bg-white rounded-3xl p-10 border border-stone-100">
            <p className="font-serif text-deep-green text-xl mb-3">講座を受けてみませんか？</p>
            <p className="text-charcoal/60 font-sans text-sm mb-6">無料サンプル動画でまず技術を確かめてから、購入を決められます。</p>
            <div className="flex justify-center gap-3 flex-wrap">
              <Link to="/providers" className="btn-primary text-sm px-8 py-3 whitespace-nowrap">事業者を探す →</Link>
              <Link to="/courses" className="btn-outline text-sm px-8 py-3 whitespace-nowrap">講座一覧を見る →</Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
